module.exports = __webpack_public_path__ + "static/media/social-fb-white.d90d4a34.svg";